import { Component, computed, inject, input, type OnInit, signal } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-header-image',
  imports: [],
  templateUrl: './header-image.component.html',
})
export class HeaderImageComponent implements OnInit {
  imageUrl = input.required<string>();
  currentUrl = signal('');

  private router = inject(Router);

  ngOnInit() {
    this.currentUrl.set(this.router.url);

    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      this.currentUrl.set(event.url);
    });
  }

  showImage = computed(() => {
    const url = this.currentUrl();
    // Hide entire navigation component on login, auth callback, and home routes
    console.log(url);
    return !url.includes('/login') && !url.includes('/auth/microsoft/redirect');
  });
}
